import { pause } from '../blackjack/blackjackMotion';
import { presentationFrames } from './baccaratModel';
export async function presentRound(round, show, { reduced = false, signal, sound } = {}) {
  for (const frame of presentationFrames(round)) {
    if (signal?.aborted) throw Object.assign(new Error('Presentation cancelled'), {name:'AbortError'});
    show(frame);
    try { sound?.(); } catch { /* cosmetic only */ }
    await pause(reduced ? 15 : 560, signal);
  }
  if (signal?.aborted) throw Object.assign(new Error('Presentation cancelled'), {name:'AbortError'});
  show(round);
}
